<span class="icon" [class.is-large]="is_large">
	<i
		[ngClass]="'icon-' + icon"
		[class.on-dark]="on_dark"
		[class.positive]="use_branding && type == 'positive'"
		[class.negative]="use_branding && type == 'negative'"
	></i>
</span>
